import axios from 'axios'
import { node } from 'prop-types'
import { useState } from 'react'
import { Button, Checkbox, Dropdown, Header, Icon, Input, Message } from 'semantic-ui-react'
import { serverUrl } from '../../../../utilites/config'

function Form() {
  const [email, setEmail] = useState('')
  const [selectedMinutes, setSelectedMinutes] = useState(1)
  const [error, setError] = useState('')
  const [termsAndConditions, setTermsAndConditions] = useState(false)
  const [submitMessage, setSubmitMessage] = useState('')
  const [submitSuccess, setSubmitSuccess] = useState<null | boolean>(null)
  const [showInfo, setShowInfo] = useState(true)

  const validateEmail = (value: string) => /^\S+@\S+\.\S+$/.test(value)

  const resetForm = () => {
    setEmail('')
    setSelectedMinutes(1)
    setTermsAndConditions(false)
  }

  const handleSubmit = async () => {
    setSubmitMessage('')
    setSubmitSuccess(null)
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.')
      return
    }
    setError('')

    try {
      await axios.post(`${serverUrl}/burst/subscription`, {
        email,
        notificationDelayMinutes: selectedMinutes,
      })
      setSubmitMessage(
        'Preferences saved. If this email was already subscribed, the notification delay was updated.'
      )
      setSubmitSuccess(true)
      resetForm()
    } catch (error: any) {
      const errorMessage = error.response?.data || 'Submission failed. Please try again.'
      setSubmitMessage(errorMessage)
      setSubmitSuccess(false)
    }
  }

  const options = [
    { key: 1, text: '1 minute', value: 1 },
    { key: 2, text: '2 minutes', value: 2 },
    { key: 5, text: '5 minutes', value: 5 },
    { key: 10, text: '10 minutes', value: 10 },
  ]

  return (
    <div className='fade-in'>
      <Header as='h1'>User form</Header>

      {showInfo && (
        <Message info size='small' style={{ marginTop: '0.5rem', position: 'relative' }}>
          <Icon
            name='close'
            style={{ position: 'absolute', top: 8, right: 10, cursor: 'pointer' }}
            onClick={() => setShowInfo(false)}
          />
          <Message.Content>
            You can disable it at any time by clicking the link in the notification email.
          </Message.Content>
        </Message>
      )}

      <div>Email address where you want to receive notifications about a solar burst event</div>
      <Input
        placeholder='Email address'
        value={email}
        style={{ marginTop: 10, maxWidth: 360 }}
        onChange={e => {
          setEmail(e.target.value)
          setError('')
        }}
        error={!!error}
      />
      {error && <div style={{ color: 'red', marginTop: 6 }}>{error}</div>}

      <div style={{ marginTop: 20 }}>
        Select the minimum time after the event to receive a notification
      </div>

      <div style={{ marginTop: 10 }}>
        <Dropdown
          placeholder='Select a threshold'
          value={selectedMinutes}
          onChange={(_, data) => setSelectedMinutes(data.value as number)}
          selection
          options={options}
        />
      </div>

      <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
        <Checkbox checked={termsAndConditions} onChange={() => setTermsAndConditions(!termsAndConditions)} />
        <div>
          I agree to the&nbsp;
          <a
            href='/policyPrivacyTemplate.pdf'
            target='_blank'
            rel='noopener noreferrer'
            style={{ textDecoration: 'underline' }}
          >
            privacy policy
          </a>
        </div>
      </div>

      <Button
        primary
        onClick={handleSubmit}
        disabled={!termsAndConditions}
        style={{ marginTop: 16, display: 'block', marginLeft: 'auto', marginRight: 0 }}
      >
        Submit
      </Button>

      {submitMessage && (
        <Message
          positive={submitSuccess === true}
          negative={submitSuccess === false}
          onDismiss={() => {
            setSubmitMessage('')
            setSubmitSuccess(null)
          }}
          style={{ marginTop: 16 }}
        >
          <Message.Header>{submitSuccess ? 'Subscription saved' : 'Something went wrong'}</Message.Header>
          <p>{submitMessage}</p>
        </Message>
      )}
    </div>
  )
}

Form.propTypes = {
  children: node,
}

export default Form
